var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-button',{staticClass:"gc-ml-2",attrs:{"icon":"","outlined":"","small":"","color":"info"},on:{"click":_vm.onClick}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'question']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }